import { connect } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';

import PropTypes from 'prop-types';

import { Box, Link } from '@mui/material';

import { unpinBuilding } from './actionCreators';

import * as buildingSelectors from './selectors';

import { PinButton } from '../Button';

const PinnedBuildingsContainer = (props) => {
  const { pinnedBuildings, unpinBuilding } = props;

  if (!pinnedBuildings?.length) return null;

  return (
    <Box ml="3rem">
      {pinnedBuildings.map(({ buildingId, buildingName }) => {
        const url = `/building/${buildingId}`;
        return (
          <Box display="flex" alignItems="center" key={buildingId}>
            <PinButton
              sx={{
                marginRight: '0.5rem',
              }}
              onClick={() => unpinBuilding(buildingId)}
            />

            <Link
              component={RouterLink}
              to={url}
              sx={{ textDecoration: 'none' }}
            >
              {buildingName}
            </Link>
          </Box>
        );
      })}
    </Box>
  );
};

PinnedBuildingsContainer.propTypes = {
  pinnedBuildings: PropTypes.instanceOf(Array).isRequired,
  unpinBuilding: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  pinnedBuildings: buildingSelectors.getPinnedBuildings(state),
});

const mapDispatchToProps = (dispatch) => ({
  unpinBuilding: (buildingId) => unpinBuilding(dispatch, buildingId),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PinnedBuildingsContainer);
